import * as metal from "@ember/-internals/metal";
    const { cached, tracked } = metal;
    export { cached, tracked };